import React, { useEffect } from "react";

import Navbar from "../../../Components/Common/navbar";
import Home from "./home";
import Footer from "./footer";
import { useUserStore } from "../../../store/store";
import MainAppDownload from "../../MainAppDownload";
import NavBottomBar from "../../../Components/Common/NavBottomBar";
import MobileViewContainer from "../../../Components/MobileViewContainer";

import kakaoChannelLogo from "../../../assets/social/kakao_channel_logo.png";

const Index = ({ isWebPurchase, isWebPurchaseTicket, isManaged }) => {
  const [siteinfo, permission] = useUserStore((state) => [state.site, state.permission]);

  return (
    <MobileViewContainer>
      <Navbar activeBar={0} permission={permission} />

      {!isWebPurchase && !isWebPurchaseTicket && isManaged && <MainAppDownload />}

      {siteinfo?.kakaoChannelsId && <div
        style={{
          position: "fixed",
          bottom: "80px",
          // left: "0",
          right: "0",
          // paddingBottom: "80px",
          paddingRight: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          zIndex: "9999",
        }}>
        <div
          style={{
            fontSize: "16px", border: "none", padding: "15px 15px", cursor: "pointer",
            backgroundColor: "#fff",
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
            borderRadius: "30px",
           }}
          onClick={() => {
            window.open(`https://pf.kakao.com/${siteinfo?.kakaoChannelsId}`, "_blank")
          }}
          className="flex justify-between items-center">
          <img
            src={kakaoChannelLogo}
            alt="Kakao Channel"
            style={{ height: "28px", marginRight: "10px" }}
          />
          <span style={{
            fontSize: "16px",
            fontWeight: "bold",
            color: "#000",
          }}>문의하기</span>
          </div>
      </div>}

      <Home permission={permission} />
      <Footer permission={permission} />

      <div style={{ height: "60px" }}></div>
      <NavBottomBar activeBar={0} />
    </MobileViewContainer>
  );
};

export default Index;
